import { Image } from 'react-bootstrap';
import Slider from 'react-slick';
import { Props } from './customSlider.type';

function CustomSlider({ cardsData }: Props) {
  const settings = {
    customPaging: function (i: number) {
      return <p className="fs-9">{cardsData[i].label}</p>;
    },
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    nextArrow: <></>,
    prevArrow: <></>,
    autoplaySpeed: 5000,
    autoplay: true
  };

  return (
    <div className="slider-container position-relative">
      <Slider {...settings}>
        {Array.isArray(cardsData) &&
          cardsData.length > 0 &&
          cardsData.map((item, index) => (
            <div
              key={`card-${index}`}
              className="mt-lg-6 mt-14 d-flex rounded slider-container_content px-lg-8 px-3"
            >
              <div className="slider-container_content_left p-lg-8 bg-body rounded-start-2">
                {item.SideContent}
              </div>
              <div className="slider-container_content_right d-lg-block d-none">
                <Image
                  src={item.image}
                  alt="card"
                  width="100%"
                  className="rounded-end-2"
                />
              </div>
            </div>
          ))}
      </Slider>
    </div>
  );
}

export default CustomSlider;
